export const BASE_IMAGE_URL = 'http://api.cybbx.com.cn/'
export const BASE_URL = '/admin/v1'
export const APP_BASE_URL = '/api'
export const BASE_FILE_URL = 'http://api.cybbx.com.cn/'
export const WEB_SOCKET_URL = 'ws://api.cybbx.com.cn:9502'
